import { render, staticRenderFns } from "./PackagesPage.vue?vue&type=template&id=a40ac634"
import script from "./PackagesPage.vue?vue&type=script&lang=js"
export * from "./PackagesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports